import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { EventEmitterEvent } from '@app/common';
import { EventEmitterType } from '@app/common/enums';


@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {

  private _event$ = new Subject<EventEmitterEvent>();

  constructor() { }

  public get event$(): Subject<EventEmitterEvent> {
    return this._event$;
  }

  public emit(type: EventEmitterType, data?: any): void {
    this._event$.next({ type, data });
  }

}
